(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvDetailController', PvDetailController);

    PvDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pv', 'Modelosdeimpresora', 'Comercio'];

    function PvDetailController($scope, $rootScope, $stateParams, previousState, entity, Pv, Modelosdeimpresora, Comercio) {
        var vm = this;

        vm.pv = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:pvUpdate', function(event, result) {
            vm.pv = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
